import {createStore} from "vuex";
import router from "./modules/router";
import ota from "./modules/otaTask";

export default createStore({
    state: {
        collapseSign: false, //侧边栏折叠 false展开 true折叠

        pageSize: 20, //分页显示条目个数

        ContentHeight: "",
        ContentWidth: "",
    },

    getters: {

        // 分页
        getPageSize(state) {
            return state.pageSize;
        },
    },

    mutations: {
        // 处理侧边栏折叠信号
        handleCollapse(state, data) {
            state.collapseSign = data;
        },
    },
    actions: {},
    modules: {
        router,
        ota,
    },
});
